import { NearbyCommunityType } from "@/types";
import { formatRent } from "@/utils/unit";

export function formatNearbyCommunityDetails(
  community: NearbyCommunityType
): string {
  let details: string = "";
  const formattedRent = formatRent(
    community.minMarketingRent,
    community.maxMarketingRent
  );
  if (formattedRent) {
    details += formattedRent;
  }

  if (
    (community.minMarketingRent || community.maxMarketingRent) &&
    community.minSqft &&
    community.maxSqft
  ) {
    details += "  •  ";
  }

  if (community.minSqft && community.maxSqft) {
    if (community.minSqft === community.maxSqft) {
      details += `${community.minSqft} sqft`;
    } else {
      details += `${community.minSqft} - ${community.maxSqft} sqft`;
    }
  }

  return details;
}
